// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__22zN9","arrow":"Tooltip_arrow__2Umfk"};